import { RouteRecordRaw } from 'vue-router'
import BaseLayoutView from '@/views/layout/BaseLayoutView.vue'
import HikiatekinSetting from '@/views/fuzoku-meisai/kaikei-kijun/HikiatekinSetting.vue'
import ExportReport from '@/views/fuzoku-meisai/kaikei-kijun/ExportReport.vue'
import KoteishisanSetting from '@/views/fuzoku-meisai/kaikei-kijun/KoteishisanSetting.vue'
import KariirekinSetting from '@/views/fuzoku-meisai/kaikei-kijun/KariirekinSetting.vue'
import YukashoukenSetting from '@/views/fuzoku-meisai/kaikei-kijun/YukashoukenSetting.vue'
import MokurokuSetting from '@/views/fuzoku-meisai/kaikei-kijun/MokurokuSetting.vue'
import JigyouhiSetting from '@/views/fuzoku-meisai/kaikei-kijun/JigyouhiSetting.vue'

export const fuzokuKaikeiKijunRoute: RouteRecordRaw = {
  path: '/fuzoku',
  component: BaseLayoutView,
  children: [
    {
      path: 'kaikei-kijun',
      children: [
        { path: 'export', component: ExportReport },
        { path: 'mokuroku', component: MokurokuSetting },
        { path: 'koteishisan', component: KoteishisanSetting },
        { path: 'hikiatekin', component: HikiatekinSetting },
        { path: 'kariirekin', component: KariirekinSetting },
        { path: 'yukashouken', component: YukashoukenSetting },
        { path: 'jigyouhi', component: JigyouhiSetting }
      ]
    }
  ]
}
